<template>
  <div style="height: 100%">
    <v-card elevation="0" class="rounded-lg textLight--text me-7" height="100%">
      <v-row align="center" class="px-4 py-10">
        <v-col cols="12" class="py-0"
          ><div class="text-start">
            <span class="text-h4 font-weight-bold">
              {{ ratingData.overallRating.toFixed(1) }}
            </span>
            <span class="text-h6 font-weight-bold">/5</span>
          </div>
        </v-col>
        <v-col cols="12" class="py-0"
          ><div class="text-start">
            <v-rating
              v-model="ratingData.overallRating"
              color="yellow darken-3"
              background-color="grey"
              empty-icon="$ratingFull"
              half-increments
              readonly
              small
            ></v-rating></div
        ></v-col>
        <v-col cols="12" class="py-0"
          ><div class="text-start text-ellipse-2">
            {{ getLocalisedValue(ratingData.question) }}
          </div></v-col
        >
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    feedbackReports: {
      type: Array,
      default: () => [],
    },
    questionVal: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ratingData: {},
    };
  },
  watch: {
    feedbackReports: {
      immediate: true,
      handler() {
        (this.ratingData.question = ""), (this.ratingData.overallRating = 0);
        if (this.feedbackReports?.length) {
          let count = 0;
          this.feedbackReports.map(obj => {
            let findVal = obj?.feedback?.questionAnswers.find(
              obj => obj.questionId === this.questionVal._id
            );
            if (findVal) {
              count++;
              this.ratingData.question = this.questionVal.question;
              this.ratingData.overallRating =
                findVal?.givenRating + this.ratingData?.overallRating;
            }
          });

          this.ratingData.overallRating = this.ratingData.overallRating
            ? this.ratingData.overallRating / (count * 2)
            : 0;
        } else {
          this.ratingData.question = this.questionVal.question;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
>>> .v-rating .v-icon {
  padding: 0;
}
</style>
